<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col
        v-if="group.industry"
        cols="12"
      >
        <v-autocomplete
          v-model="group.industry.id"
          :items="industries"
          item-text="name"
          item-value="id"
          label="Industry"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col
        v-if="group.topic && group.industry"
        cols="12"
      >
        <v-autocomplete
          v-model="group.topic.id"
          :items="topics"
          item-text="name"
          item-value="id"
          label="Topic"
          hide-details="auto"
          outlined
          :disabled="!group.industry.id"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="group.name"
          label="Name"
          hide-details="auto"
          maxlength="100"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="group.designNotes"
          label="Design Notes"
          hide-details
          outlined
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AddDesignGroup',

  data() {
    return {
      group: {},
      valid: false,
      saving: false
    };
  },
  computed: {
    topics() {
      if (this.group.industry && this.group.industry.id) {
        return this.topicsByIndustry(this.group.industry.id);
      }
      return [];
    },
    ...mapGetters({
      topicsByIndustry: 'lookup/topicsByIndustry',
      industries: 'lookup/industries'
    })
  },
  mounted() {
    this.group = { industry: {}, topic: {} };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('designgroups/create', this.group)
        .then(() => {
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE);
          this.$root.$snackbarSuccess('Design group created');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
